module.exports = __webpack_public_path__ + "img/icon(22).6e9bd116.png";